import { render, staticRenderFns } from "./inputNumber.vue?vue&type=template&id=4d50c9fa&scoped=true&"
import script from "./inputNumber.vue?vue&type=script&lang=js&"
export * from "./inputNumber.vue?vue&type=script&lang=js&"
import style0 from "./inputNumber.vue?vue&type=style&index=0&id=4d50c9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50c9fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d50c9fa')) {
      api.createRecord('4d50c9fa', component.options)
    } else {
      api.reload('4d50c9fa', component.options)
    }
    module.hot.accept("./inputNumber.vue?vue&type=template&id=4d50c9fa&scoped=true&", function () {
      api.rerender('4d50c9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vab/form/inputNumber.vue"
export default component.exports